<eds-staggered-visual
  [preTitle]="content?.preTitle"
  [title]="content?.title"
  [summary]="content?.summary"
  [imageSrc]="content?.imageSrc"
  [isContentLeft]="content?.isContentLeft"
  [btnLabel]="content?.link.displayText"
  [href]="content?.link.url"
  [btnType]="'secondary'"
  [signInRequired]="content?.link?.signInLink | ftIsSignInRequired | async"
  [hideLockIcon]="content?.link?.hideLockIcon"
  [signInTooltip]="'common.locked-link-tooltip' | translate"
  [isNewWindow]="content?.link.target"
  [externalLink]="content?.link.external"
  [secondaryTheme]="secondaryTheme"
  (onLinkClicked)="setDownloadLocation(content.downloadLocation)"
  [footnote]="content?.footnote?.value"
></eds-staggered-visual>
